import { configureStore } from '@reduxjs/toolkit'
import commonReducer from './common'
import authReducer from './auth'

export default configureStore({
    reducer: {
        common: commonReducer,
        auth: authReducer
    }
})